import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { setAuthError, clearAuthError, } from '../../core/authError/authErrorSlice.js';
import { authSuccessThunk } from '../../core/authSuccess/authSuccessSlice.js';
import { sendGlobalTrackingThunk } from '../../core/thunks.js';
import { modifyUtagDataAfterLoginsAndRegistrations } from '../../../tracking/tools.js';
import { trackAppleAttemptSuccessfulRequest } from '../../../tracking/featureSpecific/apple/index.js';
import { loginWithApple, } from './service/index.js';
export const initialStateLoginWithApple = {
    appleClientId: undefined,
    isLoading: false,
    emailUpdateRequired: false,
};
export const authWithAppleThunk = createAsyncThunk('loginWithApple/auth', async (_, { rejectWithValue, dispatch }) => {
    try {
        dispatch(clearAuthError());
        const data = await window.AppleID.auth.signIn();
        const { code } = data?.authorization || {};
        if (!code) {
            dispatch(setAuthError({ source: 'apple', code: 500 }));
            return rejectWithValue(500);
        }
        await dispatch(signInWithAppleThunk(data.authorization.code));
        return;
    }
    catch (error) {
        console.log('apple login - signIn, error: ', error);
        if (typeof error === 'string') {
            dispatch(setAuthError({ source: 'apple', message: error }));
            return rejectWithValue(400);
        }
        dispatch(setAuthError({ source: 'apple', code: error }));
        return rejectWithValue(error);
    }
});
export const signInWithAppleThunk = createAsyncThunk('loginWithApple/signIn', async (authCode, { rejectWithValue, dispatch }) => {
    try {
        const data = await loginWithApple({ authCode });
        await modifyUtagDataAfterLoginsAndRegistrations();
        if (data.status === 200 || data.status === 201) {
            dispatch(sendGlobalTrackingThunk(trackAppleAttemptSuccessfulRequest, {
                eventName: data.status === 201
                    ? [
                        'candidateLogin',
                        'candidateAccountCreation',
                        'cvMadeSearchable',
                        'CandidateAccountConfirmation',
                    ]
                    : ['candidateLogin'],
            }));
            const emailUpdateRequired = 'emailUpdateRequired' in data && data.emailUpdateRequired;
            dispatch(setEmailUpdateRequired(emailUpdateRequired));
            await dispatch(authSuccessThunk('apple', data.status, {
                apple: {
                    emailUpdateRequired,
                },
            }));
            return data;
        }
        dispatch(setAuthError({ source: 'apple', code: data.status }));
        return rejectWithValue(data);
    }
    catch (error) {
        console.log('apple login - signIn, error: ', error);
        dispatch(setAuthError({ source: 'apple', code: 500 }));
        return rejectWithValue({
            status: 500,
        });
    }
});
export const LoginWithAppleSlice = createSlice({
    name: 'loginWithApple',
    initialState: initialStateLoginWithApple,
    reducers: {
        setIsLoading: (state, actions) => {
            state.isLoading = actions.payload;
        },
        setEmailUpdateRequired: (state, actions) => {
            state.emailUpdateRequired = actions.payload;
        },
        initAppleClientId: (state, actions) => {
            state.appleClientId =
                typeof actions.payload === 'string' && actions.payload.length > 0
                    ? actions.payload
                    : undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(authWithAppleThunk.pending, (state) => {
            state.isLoading = true;
        })
            .addCase(authWithAppleThunk.rejected, (state) => {
            state.isLoading = false;
        })
            .addCase(signInWithAppleThunk.pending, (state) => {
            state.isLoading = true;
        })
            .addCase(signInWithAppleThunk.fulfilled, (state) => {
            state.isLoading = false;
        })
            .addCase(signInWithAppleThunk.rejected, (state) => {
            state.isLoading = false;
        });
    },
});
export const { initAppleClientId, setEmailUpdateRequired } = LoginWithAppleSlice.actions;
const loginWithAppleState = (state) => state.features.loginWithApple;
export const isLoadingSelector = createSelector(loginWithAppleState, ({ isLoading }) => isLoading);
export const appleClientIdSelector = createSelector(loginWithAppleState, ({ appleClientId }) => appleClientId);
export const emailUpdateRequiredSelector = createSelector(loginWithAppleState, ({ emailUpdateRequired }) => emailUpdateRequired);
export default LoginWithAppleSlice.reducer;
//# sourceMappingURL=loginWithAppleSlice.js.map